import { useRef } from "react";
import TagGroupDisplayBar from "./TagGroupDisplayBar";
import { useEventContext } from "../../contexts/EventContextProvider";
import {
    viewTagGroupDetailsByIdEvent,
    editTagGroupEvent,
    getDeleteTagGroupEvent
} from "../../events/TagGroupEvents";
import { ChevronDownSvg } from "../../icons/Icon";

const getStateColor = (discounts, id) => {
    if (discounts && discounts[id]) {
        switch (true) {
            case discounts[id].deleted:
                return 'CollectionList_DeletedRow';
            case discounts[id].error:
                return 'CollectionList_ErrordRow';
            default:
                return null;
        }
    }
};
const TagGroupList = ({ items }) => {

    const { state, eventDispatch } = useEventContext();
    const rows = useRef({});

    return (
        <div className="filter-list">
            {items &&
                items.map((item) => {

                    var backgroundColor = getStateColor(state?.tagGroups, item.id);

                    return (
                        <div key={`sticker-${item.id}`} className={`StickerItem ${backgroundColor}`}>
                            <div className="flex-row">
                                <div className="col-4">
                                    <div className='StickerItem_box flex-left'>
                                        <div className="StickerItem_tag">
                                            <em style={{ backgroundColor: `${item.color || '#ffffff'}` }}></em>
                                            <span style={{ border: `5px solid ${item.color || '#ffffff'}` }}>{item.name}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-16">
                                    <p></p>
                                </div>
                                <div className="col-3 ">
                                    <div className='StickerItem_box'>
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(editTagGroupEvent(e, item.id))}><span>edit</span></button>
                                            <button onClick={(e) => eventDispatch(getDeleteTagGroupEvent(e, item.id))}><span>delete</span></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-1 flex-middle">
                                    <div className="StickerItem_controls" >
                                        <button onClick={(e) => eventDispatch(viewTagGroupDetailsByIdEvent(e, item.id))}><span><ChevronDownSvg /></span></button>
                                    </div>
                                </div>
                            </div>
                            <TagGroupDisplayBar id={item.id} ref={(current => { rows.current[item.id] = current })} />
                        </div>
                    );
                })}
        </div>
    );
}

export default TagGroupList;